import React, { ReactNode, useState } from 'react';
import { Popover } from '@headlessui/react';
import { usePopper } from 'react-popper';

type Placement =
    | 'auto'
    | 'auto-start'
    | 'auto-end'
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'right'
    | 'right-start'
    | 'right-end'
    | 'left'
    | 'left-start'
    | 'left-end';

interface Props {
    children: ReactNode;
    referenceElement: HTMLElement;
    placement?: Placement;
}

const SimplePopover = ({
    children,
    referenceElement,
    placement = 'bottom',
}: Props) => {
    const [popperElement, setPopperElement] = useState<HTMLElement | null>(
        null,
    );
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        placement: placement,
        modifiers: [
            {
                name: 'flip',
                enabled: true,
                options: {
                    flipVariations: true,
                },
            },
            {
                name: 'offset',
                options: {
                    offset: [0, 4],
                },
            },
            { name: 'preventOverflow', enabled: true },
        ],
    });

    return (
        <Popover
            className="relative z-50 m-2 rounded-sm bg-white shadow-lg"
            ref={setPopperElement}
            style={styles.popper}
            {...attributes.popper}
        >
            {children}
        </Popover>
    );
};

export default SimplePopover;
